

// new code with only email validation

import React, { useState,useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './cdploginpage.css';


const CdpLoginPage = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(true); // State to handle loading
  const navigate = useNavigate();
  useEffect(() => {
    document.title = "Competency Development Program"; // Change browser tab title

    return () => {
      document.title = "UNext Learning Pvt Ltd"; // Reset title when component unmounts
    };
  }, []);
  useEffect(() => {
    // Simulate page initialization loading delay
    const timer = setTimeout(() => {
      setIsLoading(false); // Stop loading after 2 seconds
    }, 2000);

    return () => clearTimeout(timer); // Cleanup timeout
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true); // Show loading animation

    try {
//      const response = await fetch('http://localhost:3001/auth/login', {

        const response = await fetch('/api/login', {
  
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();
      setIsLoading(false); 

      if (data.success) {
        // Save username in localStorage or pass it as state
        localStorage.setItem('username', data.username);
        localStorage.setItem('email', data.email);
        
        navigate('/cdp/cdpfeedback');
      } else {
        setError(data.message);
      }
    } catch (error) {
      setError('An error occurred. Please try again.');
      
    }
  };
  if (isLoading) {
    // Show loading spinner while page is loading
    return (
      <div className="loading-overlay1">
        <div className="spinner1"></div>
        <p>Loading...</p>
      </div>
    );
  }
  return (

    
    <div className="login-page">

      <div className="form-container1">
      <img src="./UNextLogo2.png" alt="Logo1" className="logo" />
        <h2>Welcome</h2>
        {error && <p className="error1">{error}</p>}
        <form onSubmit={handleLogin}>
          <label>   </label>
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
                        onChange={(e) => setEmail(e.target.value)}
            required
          />

          <button type="submit" className="submit-button">Login</button>
        </form>
      </div>

      {/* Footer Section */}
      <footer className="footer">
        <p>© {new Date().getFullYear()} UNext Learning Pvt Ltd</p>
      </footer>
    </div>
    
  );
};

export default CdpLoginPage;

